import React from 'react';
import 'tachyons';
import 'typeface-open-sans';

import { AirtableDataConsumer, AirtableContextData } from '../core/AirtableDataProvider';

import './Page.scss';

interface Props { }

export default class Page extends React.Component<Props> {

  render()
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data) }
      </AirtableDataConsumer>
    );
  }

  _render(data: AirtableContextData)
  {
    const settings = data.generalParameters;

    const primary = settings.getValue('PrimaryColor');
    const secondary = settings.getValue('SecondaryColor');
    const topColor = settings.getValueOrNull('TopBarColor') || '#FFFFFF';
    const topBg = settings.getValueOrNull('TopBarBackgroundColor') || '#92999e';

    const pageNavColor = settings.getValueOrNull('PageNavColor') || '#3b4251';
    const pageNavBgColor = settings.getValueOrNull('PageNavBackgroundColor') || '#ffffff';

    return (
      <>
        <style dangerouslySetInnerHTML={{ __html: `

          .theme--primary-color {
            color: ${primary} !important;
          }
          .theme--primary-background-color {
            background-color: ${primary} !important;
          }
          .theme--primary-border-color {
            border-color: ${primary} !important;
          }
          .theme--secondary-background-color {
            background-color: ${secondary} !important;
          }
          .theme--page-nav {
            background-color: ${pageNavBgColor} !important;
          }
          .theme--page-nav, .theme--page-nav a {
            color: ${pageNavColor} !important;
          }
          .theme--top-bar, .theme--top-bar a {
            color: ${topColor} !important;
            background-color: ${topBg} !important;
          }

        `.replace('\n', '') }} />
        <div className="sans-serif mid-gray igc-page">
          { this.props.children || null }
        </div>
      </>
    );
  }

}